import { Maybe } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'arr2str', pure: false, standalone: true })
export class Arr2strPipe implements PipeTransform {
  public transform<T>(value: Maybe<readonly T[]>, pipe: PipeTransform): string {
    return value
      ? value.map(value => `${ pipe.transform(value) as string }`).join(', ')
      : '';
  }
}
